import React, { useState, useEffect, useRef } from 'react';

/**
 * Popup de aviso de inatividade
 * Exibe um countdown de 60 segundos com opções de Permanecer ou Deslogar
 */
export default function InactivityWarningPopup({ show, onStay, onLogout }) {
  const [secondsLeft, setSecondsLeft] = useState(60);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (show) {
      setSecondsLeft(60);
      intervalRef.current = setInterval(() => {
        setSecondsLeft(prev => {
          if (prev <= 1) {
            clearInterval(intervalRef.current);
            onLogout();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      clearInterval(intervalRef.current);
      setSecondsLeft(60);
    }
    return () => clearInterval(intervalRef.current);
  }, [show, onLogout]);

  if (!show) return null;

  const minutes = Math.floor(secondsLeft / 60);
  const secs = secondsLeft % 60;
  const timeDisplay = `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 99999
    }}>
      <div style={{
        background: 'white',
        borderRadius: 12,
        padding: 32,
        width: '90%',
        maxWidth: 420,
        textAlign: 'center',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
      }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>⏳</div>
        <h2 style={{ margin: '0 0 16px 0', color: 'rgb(235, 133, 0)' }}>Sessão Inativa</h2>
        <p style={{ color: '#666', marginBottom: 8, fontSize: 15 }}>
          Essa sessão vai encerrar em:
        </p>
        <div style={{
          fontSize: 42,
          fontWeight: 700,
          color: secondsLeft <= 10 ? '#d32f2f' : 'rgb(235, 133, 0)',
          marginBottom: 24,
          fontFamily: 'monospace',
          transition: 'color 0.3s'
        }}>
          {timeDisplay}
        </div>
        <div style={{ display: 'flex', gap: 16, justifyContent: 'center' }}>
          <button
            onClick={onStay}
            style={{
              padding: '14px 36px',
              fontSize: 16,
              background: 'rgb(235, 133, 0)',
              border: 'none',
              borderRadius: 8,
              color: 'white',
              cursor: 'pointer',
              fontWeight: 600
            }}
          >
            Permanecer
          </button>
          <button
            onClick={onLogout}
            style={{
              padding: '14px 36px',
              fontSize: 16,
              background: 'white',
              border: '2px solid #d32f2f',
              borderRadius: 8,
              color: '#d32f2f',
              cursor: 'pointer',
              fontWeight: 600
            }}
          >
            Deslogar
          </button>
        </div>
      </div>
    </div>
  );
}
